import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import type { Endpoint, IApiResponse } from 'src/app/models';
import { HTTP_METHOD } from '.';
import { HttpService } from '../http.service';

const CLIENT_ENDPOINT = 'Client' as Endpoint;
const SET_USER_ENDPOINT = 'SetUser' as Endpoint;

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(private readonly http: HttpService) {}

  getAccount(): Observable<IApiResponse<_GetClientAccount>> {
    return this.http.request$<_GetClientAccount>(
      HTTP_METHOD.GET,
      CLIENT_ENDPOINT,
    );
  }

  editAccount(
    firstname: string,
    lastname: string,
    phone: string,
    role: string | 'manager' | 'owner',
  ): Observable<IApiResponse> {
    return this.http.request$(HTTP_METHOD.PUT, CLIENT_ENDPOINT, {
      body: { firstname, lastname, phone, role },
    });
  }

  setMultiFactor(mfaEnabled: boolean): Observable<IApiResponse> {
    return this.http.request$(HTTP_METHOD.PUT, SET_USER_ENDPOINT, {
      body: { mfaEnabled },
    });
  }
}

type _GetClientAccount = {
  readonly firstname: string;
  readonly lastname: string;
  readonly phone: string;
  readonly role: '' | 'owner' | 'manager';
};
